import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
const serverUrl = process.env.REACT_APP_API_SERVER_URL;

if (!domain || !clientId || !audience || !serverUrl) {
    throw new Error("Missing required environment variables (Auth0 or API Server URL). Please check your .env file.");
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Auth0Provider
                domain={domain}
                clientId={clientId}
                redirectUri={window.location.origin}
                audience={audience}
                scope="openid profile email"
                cacheLocation="localstorage"
            >
                <ErrorBoundary>
                    <App />
                </ErrorBoundary>
            </Auth0Provider>
        </BrowserRouter>
    </React.StrictMode>
);